import { Capacitor } from '@capacitor/core'
import { clearAuthToken } from '../services/authToken'
function setCookie(name: string, value: string, days = 30) {
  const expires = new Date()
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)

  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`
}

function deleteCookie(name: string) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`
}

export function handleDParam() {
  if (Capacitor.isNativePlatform()) {
    return
  }

  const params = new URLSearchParams(window.location.search)

  if (!params.has('d')) {
    return
  }

  const value = params.get('d')

  if (value === 'false') {
    deleteCookie('d')
  } else if (value) {
    setCookie('d', value)
  }
  clearAuthToken().finally(() => {
    window.location.replace('/')
  })
}

export function getDParam(): string | null {
  if (Capacitor.isNativePlatform()) {
    return null
  }

  if (typeof document === 'undefined') {
    return null
  }

  const match = document.cookie.split('; ').find((row) => row.startsWith('d='))

  if (!match) {
    return null
  }

  const value = match.split('=')[1]

  return value ? decodeURIComponent(value) : null
}
